import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-btn-toggle-round',
  templateUrl: './btn-toggle-round.component.html',
  styleUrls: ['./btn-toggle-round.component.scss'],
})
export class BtnToggleRoundComponent implements OnInit {
  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  @Input() btnId: string;
  @Input() btnValue: string;
  @Input() isadminChecked: string;

  value: boolean;

  constructor() {}

  ngOnInit(): void {
    this.value = this.btnValue === 'true';
    if(this.isadminChecked==='true'){
      this.value = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.btnValue && changes.btnValue.currentValue !== changes.btnValue.previousValue){
      this.value = changes.btnValue.currentValue.toString() === 'true';
    }
  }

  onBtnClick(): void {
    this.value = !this.value;
    this.btnValue = this.value.toString();
    this.callOnClick.emit(this.btnValue);
  }
}
